import Box from "@mui/material/Box";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Divider, Grid } from "@mui/material";

export default function AvisoPrivacidad() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox textAlign="left">
            <MDTypography variant="h6" color="text" fontWeight="regular">
              En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de
              Particulares y su Reglamento, Fundación Grupo México, A.C., con domicilio en Bosque de
              Ciruelos No 99 Piso 4 Colonia Bosques de las Lomas, Ciudad de México, C.P. 11700,
              estamos conscientes de la importancia que tiene el tratamiento legítimo, controlado e
              informado de los datos personales de los usuarios de nuestro sitio web. En virtud de
              lo anterior, ponemos a su disposición la presente Política de Privacidad por medio de
              la cual, le informamos sobre el tratamiento que se dará a sus datos personales y otra
              información que se recaba a través de nuestro sitio web.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Esta Política de Privacidad es aplicable a los datos personales que Fundación Grupo
              México, A.C. (en adelante &quot;FGM &quot;) trata; la cual tiene por objeto informarle
              sobre cómo se utilizan sus datos personales, así como las medidas de seguridad que
              adopta FGM y las opciones con que usted cuenta en relación con el tratamiento de sus
              datos personales.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Recolección y procesamiento de datos personales En principio, usted puede navegar en
              nuestro sitio web sin proporcionar datos personales. Sin embargo, FGM pone a su
              disposición ciertos campos en los cuales puede voluntariamente proporcionar sus datos
              personales, por ejemplo, para registrarse en línea en nuestro sitio web, o bien para
              solicitar información sobre las actividades que realiza la Fundación y los apoyos que
              brinda. FGM puede recolectar datos personales de diversas fuentes, incluyendo pero no
              limitándose a: cuando se registre en línea en los campos provistos en nuestro sitio
              web; al crear una cuenta en nuestro sitio web; cuando se soliciten donativos o apoyos
              económicos; cuando nos contacte por cualquier razón derivada del uso de nuestros
              productos o servicios; cuando se lleven a cabo encuestas; cuando presente un
              testimonio o anécdota relacionada con FGM y/o sus productos o servicios; cuando decida
              suscribirse a alguna publicación de FGM; cuando nos presente datos personales en
              alguna forma análoga o similar a las anteriores.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Las categorías de datos personales a recabar y sujetas a tratamiento son: datos de
              identificación; datos de contacto; datos patrimoniales; datos financieros; datos
              económicos; datos laborales. Datos Personales de menores de edad
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              En FGM conocemos la importancia que tiene la protección de la privacidad y los datos
              personales de los menores de edad, por lo que FGM no obtiene, usa, divulga o almacena
              información relacionada con menores de edad, sin el consentimiento previo de su
              representante legal. Tal representante legal podrá ejercitar los derechos que por ley
              le corresponden al titular de datos personales, en este caso, el menor de edad.
            </MDTypography>
            <Divider />
            <MDTypography variant="h6" color="text">
              Finalidades del tratamiento de los datos personales
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              FGM recaba, utiliza, almacena o transfiere sus datos personales, en la medida que la
              ley lo permite, para llevar a cabo las finalidades propias de la Fundación como por
              ejemplo: la evaluación y análisis para la entrega de donativos; la formalización de
              alianzas y realización de proyectos por sí mismo o a través de terceros que sean
              acordes a su objeto; cumplimiento con obligaciones legales; desarrollo de nuevos
              productos y servicios; la adquisición o contratación de bienes y servicios; la
              participación en actividades que tengan como objetivo promover el desarrollo de las
              personas a través de proyectos sociales; seguimiento a los procesos para los cuales
              proporcionó sus datos; estudios para determinar la satisfacción de los donativos o
              apoyos económicos otorgados; creación de directorios de organizaciones no lucrativas;
              interrelación de bases de datos para conocer el perfil y las necesidades de las
              organizaciones no lucrativas.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              FGM podrá hacer uso de sus datos personales para otras finalidades, siempre y cuando
              dichas finalidades sean análogas a las anteriores y compatibles con las mismas.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Sus datos personales serán tratados únicamente por el tiempo necesario a fin de
              cumplir con las finalidades descritas y/o de conformidad con lo que establezcan las
              disposiciones legales aplicables.
            </MDTypography>
            <Divider />
            <MDTypography variant="h6" color="text">
              Medidas de seguridad
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              FGM ha adoptado medidas de seguridad, técnicas administrativas y físicas, necesarias
              para procurar la integridad de sus datos personales y evitar su daño, perdida,
              alteración, destrucción o el uso, acceso o tratamiento no autorizado. Sin embargo, es
              claro que ninguna transmisión de datos por Internet es completamente segura y por ende
              FGM no puede garantizar que el tratamiento de sus datos personales estará libre de
              todo daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no
              autorizado.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Únicamente el personal autorizado, que ha cumplido y observado los correspondientes
              requisitos de confidencialidad, podrá participar en el tratamiento de sus datos
              personales. El personal autorizado tiene prohibido permitir el acceso de personas no
              autorizadas y utilizar sus datos personales para los fines distintos a los descritos.
              La obligación de confidencialidad de las personas que participan en el tratamiento de
              sus datos personales subsiste aún después de terminada la relación con FGM.
            </MDTypography>
            <Divider />
            <MDTypography variant="h6" color="text">
              Comunicaciones y Transferencias de datos personales
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Como parte de las operaciones propias del negocio y a fin de cumplir con las
              finalidades descritas, FGM podrá compartir con terceros, nacionales o extranjeros,
              algunos o todos sus datos personales. Dichos terceros podrán ser compañías afiliadas o
              subsidiaras de FGM; asesores profesionales externos; y/u otros prestadores de
              servicios y, en general, cualquier tercero que actúe como encargado a nombre y por
              cuenta de FGM.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              FGM se asegurará, en la medida de lo posible, que dichos terceros mantengan medidas de
              seguridad, administrativas, técnicas y físicas, adecuadas para resguardar sus datos
              personales contra daño, pérdida, alteración, destrucción o el uso, acceso o
              tratamiento no autorizado de sus datos personales, así como que cumplan con la
              presente Política de Privacidad y los Avisos de Privacidad que correspondan.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              FGM no cede, vende o transfiere sus datos personales, a terceros que no guardan
              relación con FGM, sin su consentimiento previo.
            </MDTypography>
            <br />
            <MDTypography variant="h6" color="text" fontWeight="regular">
              Derechos que le corresponden al titular de los datos personales. Usted, como titular
              de datos personales, podrá ejercitar los derechos de acceso, rectificación,
              cancelación u oposición respecto al tratamiento de sus datos personales.
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>
      <Divider />
    </>
  );
}
